import { connect } from 'react-redux'

import { getUnits, deleteUnit } from '../../ducks/unit-admin'
import UnitList from '../UnitList'

export default connect(
  state => ({
    units: state.unitAdmin.get('units'),
    deletedUnits: state.unitAdmin.get('deletedUnits'),
    pagination: state.unitAdmin.get('pagination'),
    isLoading: state.unitAdmin.get('isLoading'),
    currentLanguage: state.account.get('currentLanguage')
  }),
  {
    getUnits,
    deleteUnit
  }
)(UnitList)



// WEBPACK FOOTER //
// ./src/components/smart/UnitListContainer.js